import { useGetVideos } from '@/api/videos'
import { useManagePageQueryParams } from '@/hooks/queryParams/useManagePageQueryParams'
import styled from '@emotion/styled'
import { Flex, Pagination, Text } from '@collable/ui'
import ManageVideoItem from './VideoItem'
import { useState } from 'react'

const ManageVideoList = () => {
  const [page, setPage] = useState(1)
  const { selectedChannel } = useManagePageQueryParams()
  const { data } = useGetVideos(
    {
      channelId: selectedChannel?.channelId,
      page: page - 1,
      pageSize: 10,
      sort: 'latest',
    },
    !!selectedChannel?.channelId,
  )

  return (
    <Flex direction="column">
      <TotalCount size="body3" color="labelAssistive">
        총 {data?.totalCount ?? 0}개
      </TotalCount>
      <VideoListContainer direction="column" gap={48}>
        <Flex as="ul" gap={20} direction="column">
          {data?.videos.map(video => (
            <ManageVideoItem key={video.videoId} video={video} />
          ))}
        </Flex>
        {data && data.videos.length > 0 && (
          <Pagination totalPage={data.totalPage} currentPage={page} onPageChange={setPage} />
        )}
      </VideoListContainer>
    </Flex>
  )
}

export default ManageVideoList

const TotalCount = styled(Text)`
  margin-left: 4px;
`

const VideoListContainer = styled(Flex)`
  margin-top: 24px;
  height: 100%;
  padding-bottom: 48px;

  nav {
    margin: 0 auto;
  }
`
